import React, {Component} from 'react';

// 是hash路由 history路由 自己根据需求来定
import {createHashHistory, createBrowserHistory} from 'history';

class Create extends Component {

    constructor(props) {
        super(props)
        this.handleClick = this.handleClick.bind(this)
    }

    handleClick() {
        createHashHistory().push("/user")
    }

    render() {
        return (
            <div>
                <div>name <input type="text"/></div>
                <div>email <input type="text"/></div>
                <div>
                    <button onClick={this.handleClick}>提交</button>
                </div>
            </div>
        )
    }
}

export default Create